const deviceRCLCK = {
  data () {
    return {
      editedDevice: undefined,
      editDeviceVisible: false,
      confirmDialogVisible: false,
      rightClickData: {},
      confirmDialogQuestion: '',
      confirmDialogpercentDone: 0
    }
  },
  methods: {
    async dialogDenied (data) {
      this.confirmDialogVisible = false
      this.rightClickData = {}
      this.confirmDialogQuestion = null
    },
    async dialogConfirmed (data) {
      await this.rightClickActionCommit(data)
      this.confirmDialogQuestion = null
      this.confirmDialogVisible = false
      this.rightClickData = {}
    },
    async rightClickAction (data) {
      const protectedActions = [
        'updateContents',
        'restartRenderers',
        'restartDevices',
        'restartDevicesCore',
        'restartDevicesOS',
        'updateSchedules',
        'pasteTimeRestrictions',
        'clearTags',
        'clearTimeRestrictions',
        'purgeContents',
        'resendContents',
        'identifyDevices',
        'destroyDevices'
      ]
      if (protectedActions.includes(data.action)) {
        this.confirmDialogpercentDone = 0
        this.confirmDialogQuestion = `
        ${this.$t('Are you sure you want to perform ')}
        ${this.$t(data.action)}
            ${this.$t(' on ')}
            ${this.$store.state.Device.desktops_selected_right.length}
            ${this.$t('selected devices')} ?`
        this.rightClickData = data
        this.confirmDialogVisible = true
      } else {
        await this.rightClickActionCommit(data)
      }
    },
    async __sendMassRequests (request, desktops) {
      let done = 0
      for (const desktop of desktops) {
        if (desktop.uuid) await this.sendRequest(desktop.id, request, {})
        done++
        this.confirmDialogpercentDone = parseInt((done / desktops.length) * 100, 10)
      }
    },
    async rightClickActionCommit (data) {
      const desktops = this.$store.state.Device.desktops_selected_right
      let done = 0
      switch (data.action) {
        case 'showPlaylogDevice':
          this.$emit('rightClickAction', data)
          break
        case 'updateContents':
          done = 0
          for (const desktop of desktops) {
            if (this.modificationExists(desktop)) await this.sendContentUpdateRequest(desktop)
            done++
            this.confirmDialogpercentDone = parseInt((done / desktops.length) * 100, 10)
          }
          break
        case 'resendContents':
          await this.__sendMassRequests('updateContent', desktops)
          break
        case 'identifyDevices':
          await this.__sendMassRequests('identifyDevice', desktops)
          break
        case 'requestScreenshots':
          for (const desktop of desktops) {
            await this.updateScreenshotSendRequestToDevice(desktop)
          }
          break
        case 'restartRenderers':
          await this.__sendMassRequests('restartRenderer', desktops)
          break
        case 'restartDevicesCore':
          await this.__sendMassRequests('restartCore', desktops)
          break
        case 'restartDevicesOS':
          await this.__sendMassRequests('restartOS', desktops)
          break
        case 'updateSchedules':
          await this.__sendMassRequests('updateSchedule', desktops)
          break
        case 'addToLocation':
          this.$emit('rightClickAction', data)
          break
        case 'copyTags':
          await this.$store.dispatch(
            'Clipboard/setCopiedDeviceTags',
            this.$store.state.Device.device_tags.filter(dt => dt.device.includes(data.desktop.Device.id))
          )
          break
        case 'copyTimeRestrictions':
          await this.$store.dispatch('Clipboard/setCopiedDeviceDaytimeRestrictions', data.desktop.Device_DaytimeRestrictions)
          await this.$store.dispatch('Clipboard/setCopiedDeviceDateRestrictions', data.desktop.Device_DateRestrictions)
          break
        case 'pasteTimeRestrictions':
          done = 0
          const toBeDone =
          (desktops.length * this.$store.state.Clipboard.copied_device_date_restrictions.length) +
          (desktops.length * this.$store.state.Clipboard.copied_device_daytime_restrictions.length)
          for (const desktop of desktops) {
            for (const dateRestriction of this.$store.state.Clipboard.copied_device_date_restrictions) {
              await this.$store.dispatch('Device/addDeviceDateRestriction', {
                Device: this.getDeviceFromDesktop(desktop).id,
                firstPlayDate: dateRestriction.firstPlayDate,
                lastPlayDate: dateRestriction.lastPlayDate
              })
              done++
              this.confirmDialogpercentDone = parseInt((done / toBeDone) * 100, 10)
            }
            for (const daytimeRestriction of this.$store.state.Clipboard.copied_device_daytime_restrictions) {
              await this.$store.dispatch('Device/addDeviceDaytimeRestriction', {
                Device: this.getDeviceFromDesktop(desktop).id,
                start_Monday: daytimeRestriction.start_Monday,
                end_Monday: daytimeRestriction.end_Monday,
                start_Tuesday: daytimeRestriction.start_Tuesday,
                end_Tuesday: daytimeRestriction.end_Tuesday,
                start_Wednesday: daytimeRestriction.start_Wednesday,
                end_Wednesday: daytimeRestriction.end_Wednesday,
                start_Thursday: daytimeRestriction.start_Thursday,
                end_Thursday: daytimeRestriction.end_Thursday,
                start_Friday: daytimeRestriction.start_Friday,
                end_Friday: daytimeRestriction.end_Friday,
                start_Saturday: daytimeRestriction.start_Saturday,
                end_Saturday: daytimeRestriction.end_Saturday,
                start_Sunday: daytimeRestriction.start_Sunday,
                end_Sunday: daytimeRestriction.end_Sunday
              })
              done++
              this.confirmDialogpercentDone = parseInt((done / toBeDone) * 100, 10)
            }
          }
          this.$emit('reloadRightComponent')
          break
        case 'pasteTags':
          this.$store.commit('Device/SET_RELOADING_DEVICES', true)
          const tagIds = this.$store.state.Clipboard.copied_device_tags.map(dtag => dtag.id)

          for (const desktop of desktops) {
            for (const tagId of tagIds) {
              await this.$store.dispatch('Device/addDeviceTagToDevice', [ tagId, desktop.Device ])
            }
          }
          this.$store.commit('Device/SET_RELOADING_DEVICES', false)
          break
        case 'clearTags':
          done = 0
          for (const desktop of desktops) {
            await this.$store.dispatch('Device/clearDeviceTagsFromDevice', desktop.Device)
            done++
            this.confirmDialogpercentDone = parseInt((done / desktops.length) * 100, 10)
          }
          break
        case 'clearTimeRestrictions':
          done = 0
          for (const desktop of desktops) {
            await this.$store.dispatch('Device/clearTimeRestrictions', desktop.Device)
            done++
            this.confirmDialogpercentDone = parseInt((done / desktops.length) * 100, 10)
          }
          this.$emit('reloadRightComponent')
          break
        case 'copyContent':
          const localPlaylist = await this.$store.dispatch('Medium/getPlaylistContentSimple', { id: data.desktop.LocalPlayList })
          await this.$store.dispatch('Clipboard/setCopiedLocalPlayItems', localPlaylist.PlayListItems)
          break
        case 'destroyDevices':
          done = 0
          for (const desktop of desktops) {
            await this.$store.dispatch('Device/destroy', desktop.Device)
            done++
            this.confirmDialogpercentDone = parseInt((done / desktops.length) * 100, 10)
          }
          window.location.reload()
          break
        case 'purgeContents':
          done = 0
          for (const desktop of desktops) {
            await this.$store.dispatch('Medium/getMedium', {
              data: desktop.LocalPlayList,
              options: { populate: true }
            })
            const localPlayItemsIds = this.$store.state.Medium.local_playlists_cache
              .find(medium => medium.id === desktop.LocalPlayList)
              .PlayListItems
              .map(pli => pli.id)
            if (localPlayItemsIds.length > 0) {
              await this.$store.dispatch('Medium/removePlayItemFromPlaylist', localPlayItemsIds)
              await this.$store.dispatch('Medium/getMedium', {
                data: desktop.LocalPlayList,
                options: { populate: true }
              })
            }
            done++
            this.confirmDialogpercentDone = parseInt((done / desktops.length) * 100, 10)
          }
          await this.$store.dispatch('Medium/getMediaList')
          await this.$store.dispatch('Medium/analyzeList')
          this.$emit('reloadRightComponent')
          break
        case 'removeFromGroup':
          done = 0
          for (const desktop of desktops) {
            await this.$store.dispatch('Device/assignDesktopToGroup', [desktop.id, null])
            done++
            this.confirmDialogpercentDone = parseInt((done / desktops.length) * 100, 10)
          }
          this.$emit('reloadRightComponent')
          break
        case 'deleteGroup':
          done = 0
          for (const desktop of desktops) {
            await this.$store.dispatch('Device/assignDesktopToGroup', [desktop.id, null])
            done++
            this.confirmDialogpercentDone = parseInt((done / desktops.length) * 100, 10)
          }
          await this.$store.dispatch('Device/destroyDesktopGroup', data.desktopgroup)
          this.$emit('reloadRightComponent')
          break
        default:
          try {
            await this[data.action](data.desktop)
          } catch (error) {
            console.error('Unknown action ' + data.action)
          }
          break
      }
    },
    async openRightClickMenu (desktop, $event) {
      this.$emit('closeRightClickMenu')
      // It has to be cloned to get rid of Vue warnings and I do not want lodash for it...
      const desktopCloned = JSON.parse(JSON.stringify(desktop))
      if (!desktopCloned.Device.id) desktopCloned.Device = JSON.parse(JSON.stringify(this.$store.state.Device.device_list.find(d => d.id === desktopCloned.Device)))
      this.$refs.RightClickDesktopMenu.openRightClickMenu(desktopCloned, $event)
      this.$emit('closeLeftPanelContextMenu')
    },
    closeRightClickMenu () {
      if (this.$refs.RightClickDesktopMenu) this.$refs.RightClickDesktopMenu.closeRightClickMenu()
    },
    editDevice (desktop, tab = 'heartbeat') {
      this.editedDevice = isNaN(desktop.Device) ? desktop.Device : this.$store.state.Device.device_list.find(d => d.id === desktop.Device)
      this.editedDeviceId = this.editedDevice.id
      this.editDeviceVisible = true
      this.$nextTick(() => this.$refs['EditDevice'].setActiveTab(tab))
    },
    async closeEditDevice () {
      await this.$store.dispatch('Device/reloadDeviceFromApi', this.editedDevice.id)
      this.editedDeviceId = undefined
      this.editedDevice = undefined
      this.editDeviceVisible = false
    }
  },
  computed: {
  }
}
export default deviceRCLCK



// WEBPACK FOOTER //
// ./src/components/Common/deviceRCLCK.mixin.js